import { formatUnits } from "viem";

export function formatCompact(value: bigint, decimals = 18, maxFractionDigits = 4): string {
  // Convert to Number for Intl.NumberFormat. Acceptable precision loss for display.
  const numeric = Number(formatUnits(value, decimals));
  if (!Number.isFinite(numeric)) return "0";
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: maxFractionDigits,
    notation: numeric >= 1_000_000 ? "compact" : "standard",
  }).format(numeric);
}

export function formatBnb(value: bigint): string {
  return `${formatCompact(value, 18, 5)} BNB`;
}

export function formatToken(value: bigint, symbol = "TOKEN", decimals = 18): string {
  return `${formatCompact(value, decimals, 4)} ${symbol}`;
}

export function formatBps(value: bigint): string {
  return `${Number(value) / 100}%`;
}

export function formatDuration(seconds: bigint): string {
  // Convert bigint to safe Number (durations fit in Number range comfortably).
  const s = Number(seconds);
  if (!Number.isFinite(s) || s <= 0) return "0时";

  const days = Math.floor(s / 86_400);
  const hours = Math.floor((s % 86_400) / 3600);
  const mins = Math.floor((s % 3600) / 60);

  if (days > 0) return hours > 0 ? `${days}天 ${hours}时` : `${days}天`;
  if (hours > 0) return mins > 0 ? `${hours}时 ${mins}分` : `${hours}时`;
  if (mins > 0) return `${mins}分`;
  return `${s}秒`;
}

export function isPositive(value: bigint | undefined): value is bigint {
  return typeof value === "bigint" && value > 0n;
}
